import { Data2, newId, dateToString } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { Currency } from '../../../tables/types/types'
import { useSystemStateHooks } from '../../system'
import { TaxItem, Ticket, TicketType } from '../state/types'

export const useTicketBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildTicket = (data: Data2) => {
        const {
            id = newId(),
            code,
            parentTable,
            parentId,
            type,
            creationDate,
            dueDate,
            taxItems,
            subtotal,
            vatAmount,
            total,
            payedAmount,
            currency,
            ticketUrl
        } = data
        const ticket: Ticket = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            parentTable: parentTable! as TableName,
            parentId: parentId! as string,
            type: type! as TicketType,
            creationDate: dateToString(creationDate || new Date())!,
            dueDate: dateToString(dueDate)!,
            taxItems: (taxItems || []) as TaxItem[],
            subtotal: subtotal! as number,
            vatAmount: vatAmount! as number,
            total: total! as number,
            payedAmount: payedAmount! as number,
            currency: currency! as Currency,
            ticketUrl: ticketUrl as O<string>
        }
        
        return ticket
    }

    return {
        buildTicket
    }
}
